export default {
	promoCode: ''
};
